export default __webpack_public_path__ + "static/media/club_de_asistencias.0bbe5053.svg";